// @flow
import React, { Component } from 'react';
import { ButtonInput } from './ButtonStyles';
import { SubmitValidationSmall } from './InputStyles';

type P = {|
  value: string,
  disabled: boolean,
  error: ?string,
  marginTop: string
|};

class SubmitButton extends Component<P> {
  static defaultProps = {
    marginTop: '5rem'
  };

  render() {
    return (
      <>
        <ButtonInput
          type="submit"
          {...this.props}
          marginTop={this.props.marginTop}
        />
        {this.props.error && (
          <SubmitValidationSmall>{this.props.error}</SubmitValidationSmall>
        )}
      </>
    );
  }
}

export default SubmitButton;
